import React, { Component } from 'react'
import $ from 'jquery'

import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect, withRouter, Link } from 'react-router-dom'

import {
    addModal,
    popModal
} from '../../../actions/appAction';

import {
    translate
} from 'react-switch-lang'

export class GetPaidConfirmation extends Component {

    constructor(){
        super();
        this.state = {
            modalZ : 1050
        }
    }

    componentDidMount(){

        const { isOpened } = this.props;
        
        if(isOpened){
            $('#getPaidConfirmationModal').modal({backdrop:'static', keyboard:false});
            $('#getPaidConfirmationModal .modal-dialog').attr('class','modal-dialog modal-dialog-centered slideInDown animated')
            $('#getPaidConfirmationModal').modal('show');
            this.props.addModal('get-paid-confirmation-modal')
            $('.modal-backdrop').eq($('.modal-backdrop').length-1).addClass("gpc-bd");
        }

    }

    componentDidUpdate(prevProps){
        if(prevProps.modalInstances!==this.props.modalInstances){
            let modalInstance = this.props.modalInstances.find( (data) => data.modal_class==="get-paid-confirmation-modal");
            if(modalInstance!==undefined){
                $('.gpc-bd').css('z-index',`${modalInstance.z_index-10}`)
                this.setState({
                    modalZ : modalInstance.z_index
                })
            }
        }
    }


    componentWillUnmount(){
        $('#getPaidConfirmationModal').modal('hide');
        this.props.popModal()
    }

    render () {

        const { modalZ } = this.state;
        const { balance } = this.props;

        const { isMobileView } = this.props;

        let modalDialogClass = isMobileView ? "mobile-modal" : "" 

        const { t , currentLanguage } = this.props;

        return (
            <div style={{ zIndex : `${modalZ}` }} className={` ${modalDialogClass} get-paid-confirmation-modal modal fade modal-opaque`} id="getPaidConfirmationModal" tabIndex="-1" role="dialog" aria-labelledby="helpTaskModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        {
                            isMobileView ?
                            <div className="mobile-custom-header modal-header">
                                <div className="row" style={{ width: "100%" }}>
                                    <div className="col" style={{ textAlign : "left" }}>
                                        <img style={{ display: "block", width: "150px" }} src={require('../../../images/tarjemle-logo.png')}/>
                                    </div>
                                    <div className="col" style={{ textAlign : "right", paddingRight : "0" }}>
                                        <button onClick={this.props.closeGetPaidConfirmationModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span className="close-modal-btn" aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="custom-modal-header modal-header">
                                <button onClick={this.props.closeGetPaidConfirmationModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span className="close-modal-btn" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        }
                        
                        <div className="modal-body">
                            <p className="confirmation-header">{t('common_get_paid_now')}</p>
                            <p className="confirmation-sub-header">{t('task_modal_get_payment')} ${balance.toFixed(2)}</p>
                            <button style={{ textTransform : "uppercase" }} className="btn-ok" onClick={this.props.confirm}>{t('common_get_paid_now')}</button>    
                        </div>
                    
                    </div>
                </div>
            </div>
        )

    }


}

const mapStateToProps = state => {
    return {
        modalInstances : state.app.modalInstances,
        isMobileView : state.app.isMobileView
    }
}

export default compose(
    withRouter,
    connect(mapStateToProps, { 
        addModal,
        popModal
    })
)(GetPaidConfirmation)